import { render, staticRenderFns } from "./AdminClientes.vue?vue&type=template&id=8425a19c&scoped=true"
import script from "./AdminClientes.vue?vue&type=script&lang=js"
export * from "./AdminClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8425a19c",
  null
  
)

export default component.exports